export default __webpack_public_path__ + "static/media/icon.1dc08a47.png";